// Module
var code = "<!-- ko if: _visible --> <a data-bind=\"click: OnClick\" class=\"text-sm sps-btn sps-btn-outline btn-color-static-refresh securityEditor\"> <i class=\"fa fa-lock\"></i><span><!-- ko text: _labels.SECURITY_EDITOR_LABEL --><!-- /ko --></span> </a> <!-- /ko -->";
// Exports
export default code;